// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*-----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/

/* <DEPRECATED> */
.jupyter-widgets.widget-output .jp-OutputArea-prompt, /* <DEPRECATED> */
.jupyter-widgets.jupyter-widget-output .jp-OutputArea-prompt {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./css/output.css"],"names":[],"mappings":"AAAA;;;8EAG8E;;AAE9E,iBAAiB;AACjB;;EAEE,aAAa;AACf","sourcesContent":["/*-----------------------------------------------------------------------------\n| Copyright (c) Jupyter Development Team.\n| Distributed under the terms of the Modified BSD License.\n|----------------------------------------------------------------------------*/\n\n/* <DEPRECATED> */\n.jupyter-widgets.widget-output .jp-OutputArea-prompt, /* <DEPRECATED> */\n.jupyter-widgets.jupyter-widget-output .jp-OutputArea-prompt {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
